export default {
  lang: {
    selectAll: 'Wybierz wszystkie strony',
    selected: 'Wybrane',
    term: 'Artykuł',
    deselect: 'Odzyskany',
  },
};
